<template>
  <div>
    <div id="top" class="clearfix">
      <div class="top boxcenter clearfix">
        <h1>
          <a href="http://www.cfbond.com" target="_blank">
            <img src="http://www.cfbond.com/static/images/logo.png" />
          </a>
          <span>· 保险排行榜</span>
        </h1>
        <ul class="fl clearfix">
          <li
            @click="navChecked(index,item.img[0])"
            v-for="(item,index) in nav"
            :key="index"
            :class="{on:isNavOn == index}"
          >
            <a>{{item.name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="m_top_tab clearfix">
      <a
        @click="navChecked(index,item.img[1])"
        v-for="(item,index) in nav"
        :key="index"
        :class="{on:isNavOn == index}"
      >{{item.name}}</a>
    </div>
    <div id="banner">
      <img :src="bannerBG" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: [
        {
          name: "保险月度榜",
          img: [
            require("../../images/bxcp_banner.jpg"),
            require("../../images/bxcp_m_banner.jpg")
          ]
        },
        {
          name: "保险季度榜",
          img: [
            require("../../images/bxcp_banner2.jpg"),
            require("../../images/bxcp_m_banner2.jpg")
          ]
        }
      ],
      isNavOn: 0,
      bannerBG: ""
    };
  },
  created() {
    this.bannerBG =
      document.body.clientWidth > 768
        ? require("../../images/bxcp_banner.jpg")
        : require("../../images/bxcp_m_banner.jpg");
  },
  methods: {
    //导航栏选中
    navChecked(index, img) {
      this.isNavOn = index;
      this.bannerBG = img;
      this.$emit("topNavEvent", this.isNavOn);
    }
  }
};
</script>

<style scoped>
#top {
  height: 97px;
  margin: 0 auto;
  max-width: 1920px;
  overflow: hidden;
}

#top h1 {
  font-size: 14px;
  line-height: 97px;
  width: 430px;
  float: left;
}

#top h1 img {
  margin-top: -15px;
}

#top h1 a {
  color: #373737;
}

#top h1 span {
  font-size: 20px;
  font-weight: bold;
  padding: 0 20px;
  color: #333;
}

#top ul {
  margin: 10px 0;
}

#top ul li {
  float: left;
  margin: 0 30px;
  line-height: 77px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
}

#top ul li.on {
  color: #ff6f29;
  border-bottom: 2px solid #ff6f29;
}

#top ul li a,
#top ul li a:hover {
  color: #333;
  text-decoration: none;
}

#top ul li.on a {
  color: #ff6f29;
}

.m_top_tab {
  display: none;
}

#banner {
  height: 360px;
  position: relative;
  min-width: 1200px;
  overflow: hidden;
}
#banner img {
  height: 100%;
  display: block;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
@media screen and (min-width: 100px) and (max-width: 768px) {
  #top {
    display: none;
  }
  .boxcenter {
    width: 100%;
    margin: 0 auto;
  }

  .m_top_tab {
    display: block;
  }
  .m_top_tab a {
    text-decoration: none;
    display: block;
    float: left;
    width: 50%;
    text-align: center;
    height: 40px;
    color: #333;
    background: #f6f6f6;
    line-height: 40px;
    font-size: 17px;
  }
  .m_top_tab a.on {
    background: #fff;
  }

  #banner {
    height: 40vw;
    min-width: 100%;
  }
  #banner img {
    width: 100%;
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header/homeHeader.vue